import esLocale from "date-fns/locale/es";
import i18n from "../i18n";

export const getDateFnsLocale = () => (i18n.language?.startsWith("es") ? esLocale : undefined);
